
export enum RouteDetailCd {
	SHIPMENTS = 'Shipments'}
